/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "889dbf024e51e2770852919be9d691813b277da7";
